import React, { useEffect } from 'react'
import { Button, Flex, HStack, Progress, Spacer, useDisclosure } from '@chakra-ui/react'
import Header from '../../components/ui/Layout/Header'
import ContainerContent from '../../components/ui/Layout/ContainerContent'

import rootStore from '../../store/RootStore'
import ACLReportUsers from '../../components/features/AccessControl/ACLProductUsers/ACLReportUsers'
import { ACLContext } from '../../contexts/ACLContext'
import UserManagerModal from './UserManagerModal/UserManagerModal'
import ReactGA from 'react-ga4'
import { observer } from 'mobx-react'

const AccessControlPage = () => {
  const {
    productsStore: { reports, loadingReports },
  } = rootStore
  const { isOpen, onClose, onOpen } = useDisclosure()

  /**
   * Google Analytics
   */
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: '/access-control',
      title: 'Login',
    })
  }, [])

  const handleOpenUserManagerModal = () => {
    onOpen()
  }

  return (
    <ACLContext.Provider
      value={{ openUserManagerModal: handleOpenUserManagerModal }}>
      <Header
        title="Section Access"
        reportTitle="Users and sections permissions"
      />
      <ContainerContent
        maxW={1170}
        p={'32px 0 120px 0'}>
        {loadingReports && (
          <Progress
            isIndeterminate
            height={2}
          />
        )}
        <ACLReportUsers reports={reports} />
        <Footer />
      </ContainerContent>
      <UserManagerModal
        isOpen={isOpen}
        onClose={onClose}
      />
    </ACLContext.Provider>
  )
}

const Footer = observer(() => {
  const {
    accessControlStore: { saveAccessControl, savingAcl },
  } = rootStore
  return (
    <Flex
      left={0}
      right={0}
      position="fixed"
      bg="white"
      height="100px"
      w="full"
      boxShadow="0px -4px 10px rgba(0, 0, 0, .05)"
      bottom={0}>
      <ContainerContent
        maxW={1170}
        p={'32px 0'}>
        <HStack gap={2}>
          <Spacer />
          <Button
            colorScheme="blackAlpha"
            w={120}
            onClick={() => window.history.back()}>
            Cancel
          </Button>
          <Button
            colorScheme="orange"
            w={120}
            onClick={saveAccessControl}
            isLoading={savingAcl}>
            Save
          </Button>
        </HStack>
      </ContainerContent>
    </Flex>
  )
})

AccessControlPage.propTypes = {}
export default AccessControlPage
